import { useCallback, useSyncExternalStore } from 'react';
import { mediaQuery, type Breakpoint } from '../tokens/breakpoints';

/** Live `matchMedia` result. Server/first render assumes false (mobile-first). */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof matchMedia !== 'function') return () => {};
      const mq = matchMedia(query);
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => typeof matchMedia === 'function' && matchMedia(query).matches,
    () => false,
  );
}

/** True from the given breakpoint up, e.g. `useBreakpoint('md')`. */
export const useBreakpoint = (bp: Breakpoint) => useMediaQuery(mediaQuery(bp));

export const usePrefersReducedMotion = () => useMediaQuery('(prefers-reduced-motion: reduce)');
